import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user.js';
import config from './modules/config.js';
import voiceAI from './modules/voiceAI.js';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: { user, config, voiceAI },
  getters,
});

export default store;
